import React from 'react';
import PropTypes from 'prop-types';
import styled, { withTheme } from 'styled-components';
import { Icon } from '../icon';
import { Sidebar } from '../sidebar';
import Image from '../Image';
import { makeNavbar, makeBrand, makeBrandLink, makeCollapse, makeContent, makeToggleNavbar, makeNavbarIcons, } from './mixins';
const NavbarComponent = styled.div `
  ${props => makeNavbar(props)}
`;
const Brand = styled.span `
  ${props => makeBrand(props)}
`;
const BrandLink = styled.a `
  ${props => makeBrandLink(props)}
`;
const Collapse = styled.div `
  ${props => makeCollapse(props)}
`;
const CollapseContent = styled.div `
  ${props => makeContent(props)}
`;
const SidebarContent = styled.div `
  ${props => makeContent(props)}
`;
const ToggleNavbar = styled.div `
  ${props => makeToggleNavbar(props)}
`;
const NavbarIcon = styled(Icon) `
  ${props => makeNavbarIcons(props)}
`;
const getSidebarNav = (isNavbarContentVisible, toggleNavbarContent, isMobile, hideSearchBar, children) => {
    return (React.createElement(Sidebar, { position: "left", visible: isNavbarContentVisible, handleClose: toggleNavbarContent, closeType: "back" },
        React.createElement(SidebarContent, { hideSearchBar: hideSearchBar }, children && children)));
};
const getCollapseNav = (isNavbarContentVisible, toggleNavbarContent, isMobile, hideSearchBar, children) => {
    return (React.createElement(Collapse, { position: "left", visible: isNavbarContentVisible, handleClose: toggleNavbarContent },
        React.createElement(CollapseContent, { hideSearchBar: hideSearchBar }, children && children)));
};
export class NavbarClass extends React.Component {
    constructor(props) {
        super(props);
        this.componentDidMount = () => {
            this.setResize();
            window.addEventListener('resize', this.setResize);
        };
        this.setResize = () => {
            const isMobileSize = window.innerWidth < 1200;
            this.setState({
                isMobile: isMobileSize,
            });
        };
        this.toggleMenu = () => {
            const { isNavbarContentVisible } = this.state;
            this.setState({
                isNavbarContentVisible: !isNavbarContentVisible,
            });
        };
        this.closeMenu = () => {
            this.setState({
                isNavbarContentVisible: false,
            });
        };
        this.state = {
            isMobile: true,
            isNavbarContentVisible: false,
        };
    }
    render() {
        const { children, logo, isNavbarContentVisible, toggleNavbarContent, hideSearchBar, callback, theme, url = '/' } = this.props;
        const { isMobile } = this.state;
        const redirect = (e, item) => {
            e.preventDefault();
            if (callback)
                callback(item);
            window.location.href = item.href;
        };
        return (React.createElement(NavbarComponent, null,
            isMobile && (React.createElement(ToggleNavbar, null,
                React.createElement(NavbarIcon, { onClick: toggleNavbarContent, name: "icon-light-menu", color: theme.colors.primary.normal }))),
            React.createElement(Brand, null,
                React.createElement(BrandLink, { href: url, onClick: e => redirect(e, { content: 'Ir a Home', href: url }) },
                    React.createElement(Image, { src: `${logo.src}`, width: `${logo.width}`, height: `${logo.height}`, alt: `${logo.alt}`, className: `${logo.class}`, preload: true }))),
            isMobile
                ? getSidebarNav(isNavbarContentVisible, toggleNavbarContent, isMobile, hideSearchBar, children)
                : getCollapseNav(isNavbarContentVisible, toggleNavbarContent, isMobile, hideSearchBar, children)));
    }
}
NavbarClass.propTypes = {
    isNavbarContentVisible: PropTypes.bool.isRequired,
    toggleNavbarContent: PropTypes.func.isRequired,
    hideSearchBar: PropTypes.bool,
    children: PropTypes.node.isRequired,
    logo: PropTypes.shape({
        src: PropTypes.string,
        width: PropTypes.string,
        height: PropTypes.string,
        alt: PropTypes.string,
        class: PropTypes.string,
        hide: PropTypes.bool,
    }).isRequired,
    callback: PropTypes.func,
    url: PropTypes.string
};
NavbarClass.defaultProps = {
    hideSearchBar: false,
    callback: () => { },
};
export const Navbar = withTheme(NavbarClass);
